import { render, staticRenderFns } from "./ActiveClients.vue?vue&type=template&id=4fdbaa35&scoped=true"
import script from "./ActiveClients.vue?vue&type=script&lang=ts"
export * from "./ActiveClients.vue?vue&type=script&lang=ts"
import style0 from "./ActiveClients.vue?vue&type=style&index=0&id=4fdbaa35&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fdbaa35",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fdbaa35')) {
      api.createRecord('4fdbaa35', component.options)
    } else {
      api.reload('4fdbaa35', component.options)
    }
    module.hot.accept("./ActiveClients.vue?vue&type=template&id=4fdbaa35&scoped=true", function () {
      api.rerender('4fdbaa35', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manage/projectDetails/Clients/ActiveClients.vue"
export default component.exports